<div>
  <h1>502</h1>
  <h2> {{ 'administration_internalServerError_label' | translate }} <b>:(</b></h2>
  <div class="gears">
    <div class="gear one">
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
    <div class="gear two">
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
    <div class="gear three">
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
  </div>
  <div class="text-center" style="margin-top: 200px;">
    <button type="button" (click)="goToHome()" class="btn btn-outline-primary btn-rounded waves-effect">{{ 'administration_goToHome_label' | translate }}</button>
  </div>
</div>
